export default "__VITE_ASSET__B795Vk4A__"